/**
 * @generated SignedSource<<513d7f919c579d2248fb418730db53cb>>
 * @relayHash f5d07637afe71c7ca06b7f159493ea94
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  otherContentStatus: string;
  transitionType?: ConfluenceApprovalTransitionType | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null | undefined;
    readonly displayProperties: {
      readonly color: string | null | undefined;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null | undefined;
      readonly contentStatus: string | null | undefined;
      readonly contentVersion: number | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly isActive: boolean | null | undefined;
      readonly lastModificationDate: {
        readonly value: string;
      } | null | undefined;
      readonly modifier: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly workflowId: string | null | undefined;
      readonly workflowStatusId: string | null | undefined;
    } | null | undefined;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null | undefined;
      readonly creator: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly creatorAaid: string | null | undefined;
      readonly id: string;
      readonly reviewComment: string | null | undefined;
      readonly reviewLastModified: {
        readonly value: string;
      } | null | undefined;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null | undefined;
        readonly decisionId: string | null | undefined;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null | undefined;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null | undefined;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null | undefined;
        readonly reviewerId: string | null | undefined;
        readonly user: {
          readonly displayName: string | null | undefined;
          readonly id: string | null | undefined;
          readonly isActive: boolean | null | undefined;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null | undefined;
            readonly value: string | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
  } | null | undefined;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null | undefined;
  } | null | undefined;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null | undefined;
      readonly version: {
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "otherContentStatus"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "transitionType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "status"
},
v3 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "args": [
    (v4/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v7 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v8 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v9 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v10 = [
  (v4/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "success"
},
v12 = {
  "kind": "ScalarField",
  "name": "message"
},
v13 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v14 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v15 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/)
      ]
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v17 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v16/*: any*/)
  ]
},
v18 = [
  (v4/*: any*/),
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  (v8/*: any*/),
  (v9/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v20 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v21 = {
  "kind": "ScalarField",
  "name": "value"
},
v22 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v23 = [
  (v5/*: any*/),
  (v20/*: any*/),
  (v19/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v21/*: any*/),
      (v22/*: any*/)
    ]
  }
],
v24 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v23/*: any*/)
},
v25 = [
  (v21/*: any*/)
],
v26 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v19/*: any*/),
    (v24/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v25/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v23/*: any*/)
    }
  ]
},
v27 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v25/*: any*/)
    },
    (v16/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v25/*: any*/)
    },
    (v24/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        {
          "kind": "ScalarField",
          "name": "principalType"
        },
        {
          "kind": "ScalarField",
          "name": "principalId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v25/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v20/*: any*/),
            (v19/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v22/*: any*/),
                (v21/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v28 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v13/*: any*/),
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v5/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      (v6/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v10/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v15/*: any*/),
          (v17/*: any*/)
        ]
      },
      {
        "args": (v18/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v15/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      },
      (v6/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v10/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v28/*: any*/),
          (v17/*: any*/)
        ]
      },
      {
        "args": (v18/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v28/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f5d07637afe71c7ca06b7f159493ea94",
    "id": "e06bae9b53fed308323ff160bb05ef64aa4f85f29d323bf65f26f5773bb16d27",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType){content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "a2315c6dd75143b0285f57068b70bc22";

export default node;
